export const leaftechBrandColors = {
  primary: "#2459ea",
};

export const wagoBrandColors = {
  primary: "#6EC800",
};

export const enakonBrandColors = {
  primary: "#00519e",
};
